import { TSmeAddress, TSmeSyncAddress } from "types/sme.type";
import {
  normaliseAndSplitAddress,
  shiftPropertyName,
  shiftPropertyNumber,
} from "./integration-address.utils";

export const getSmeSegmentedAddress = (
  address: string | null,
  postcode: string | null
): TSmeSyncAddress => {
  const smeAddress = {
    building_name: "",
    building_number: "",
    address_line_one: "",
    address_line_two: "",
    address_line_three: "",
    address_line_four: "",
    postcode: postcode || "",
  };

  if (!address) {
    return smeAddress;
  }

  const splitAddress = normaliseAndSplitAddress(address, postcode);

  smeAddress.building_name = shiftPropertyName(splitAddress);
  smeAddress.building_number = shiftPropertyNumber(splitAddress);

  const [
    address_line_one,
    address_line_two,
    address_line_three,
    ...rest
  ] = splitAddress.slice();

  const address_line_four = rest.join(", ");

  const result = {
    ...smeAddress,
    address_line_one,
    address_line_two,
    address_line_three,
    address_line_four,
  };

  return result;
};

export const transformAddress = (
  smeSyncAddress: TSmeSyncAddress
): TSmeAddress => {
  const {
    building_name,
    building_number,
    address_line_one,
    address_line_two,
    address_line_three,
    address_line_four,
    postcode,
  } = smeSyncAddress;

  const combinedLineOne =
    (building_name ? `${building_name} ,` : "") +
    (building_number ? ` ${building_number}` : "") +
    (address_line_one ? ` ${address_line_one}` : "");

  const transformedAddress: TSmeAddress = {
    address_line_one: combinedLineOne.trim(),
    address_line_two,
    address_line_three,
    address_line_four,
    postcode,
  };

  return transformedAddress;
};
